document.documentElement.classList.remove('no-js');
document.addEventListener('click', (e) => {
  const q = e.target.closest('[data-quantity]');
  if (q) {
    const input = q.parentElement.querySelector('input');
    const next = Math.max(1, Number(input.value || 1) + Number(q.dataset.quantity));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const thumb = e.target.closest('[data-product-image]');
  if (thumb) {
    const main = document.querySelector('[data-main-product-image]');
    if (main) { main.src = thumb.dataset.productImage; main.srcset = ''; }
  }
});
